import ClauseLibrary from './Page';
export default ClauseLibrary;
